import './style.scss';

import React, { useState } from 'react';
import { Marker } from 'react-google-maps';
import Map from 'src/components/Map';
import { Button, Icon, Tooltip } from 'straightline-ui';

const getMapProps = (
  address = { position: { lng: -98.5795, lat: 39.8283 } },
  shipments = []
) => {
  const markers = shipments.map((shipment) => {
    const pickup_position = shipment.pickup_address.position;
    const delivery_position = shipment.delivery_address.position;
    if (
      pickup_position.lat === address.position.lat &&
      pickup_position.lng === address.position.lng
    ) {
      return delivery_position;
    }
    return pickup_position;
  });

  return {
    center: [address.position, ...markers],
    markers
  };
};

const Expand = ({ onClick, expanded }) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const handleClick = (event) => {
    toggle();
    return onClick(event);
  };

  return (
    <React.Fragment>
      <Button
        id="mapToggle"
        color="white"
        className="btn-rounded-circle"
        onClick={handleClick}
        style={{
          position: 'absolute',
          left: 'calc(50% - 20px)',
          bottom: '3.2rem',
          zIndex: 1
        }}
      >
        {expanded ? <Icon type="chevron-up" /> : <Icon type="chevron-down" />}
      </Button>
      <Tooltip
        placement="top"
        // Not much we can do about the arrow color bc it is an
        // ::after css content
        innerClassName="bg-white"
        target="mapToggle"
        toggle={toggle}
        isOpen={isOpen}
      >
        {expanded ? 'Collapse Map' : 'Expand Map'}
      </Tooltip>
    </React.Fragment>
  );
};

export default function MapHeaderAddress({ address, shipments }) {
  const [expanded, setExpanded] = useState(false);

  const { center, markers } = getMapProps(
    address.position ? address : undefined,
    shipments
  );

  return (
    <div className="map-header-address">
      <Map
        center={center}
        zoom={address?.position ? undefined : 5}
        defaultOptions={{
          zoomControlOptions: {
            // google.maps.ControlPosition.TOP_RIGHT = 3
            position: 3
          }
        }}
        containerClassName={`map-header-container ${expanded ? 'open' : ''}`}
      >
        {address?.position && (
          <Marker position={address.position} color="red" />
        )}

        {markers.map((position, index) => {
          return (
            <Marker
              key={index}
              position={position}
              icon="http://maps.google.com/mapfiles/ms/micons/blue.png"
            />
          );
        })}
      </Map>
      <Expand expanded={expanded} onClick={() => setExpanded(!expanded)} />
    </div>
  );
}
